import { Archive } from "lucide-react";
import type { ModuleManifest } from "@/modules/module-registry";
import type { PermissionDefinition } from "@/modules/access";

// What the optional DMS module lets staff grant. `dms-app`: read: open the app. `dms`: read: see the contacts; write: add, edit and bin them. Both are needed to open the app. `dms-sensitive`: read: see sensitive documents; write: change them (needs `dms` too).
const dmsPermissions: readonly PermissionDefinition[] = [
  { resource: "dms-app", label: "dms-app.resource", levels: ["read"], ownable: false, staffOnly: true },
  { resource: "dms", label: "dms.resource", levels: ["read", "write"], ownable: false, staffOnly: true },
  { resource: "dms-sensitive", label: "dms-sensitive.resource", levels: ["read", "write"], ownable: false, staffOnly: true },
];

/** The DMS (document management) module declares itself: an optional app, off until an administrator switches it on in the App store. It needs no other module and adds nothing to them. */
export const dmsManifest: ModuleManifest = {
  id: "dms", href: "/dms", icon: Archive,
  name: "auth.modules.dms", description: "settings.appStore.apps.dms.description",
  permissionDefinitions: dmsPermissions,
  permissions: ["dms-app", "dms", "dms-sensitive"], appPermission: "dms-app", needs: [], contributes: [],
  optional: true,
};
